import Facebook from '@mui/icons-material/Facebook'
import Instagram from '@mui/icons-material/Instagram'
import YouTube from '@mui/icons-material/YouTube'

// TODO: Rename this to something else (i.e. Post types)
export const NETWORKS = [
    {
        displayName: 'Post to Story',
        canonicalName: 'instagram_story',
        tooltip: 'Visible for 24 hours',
        icon: <Instagram sx={{ color: '#d62976' }} />,
    },
    {
        displayName: 'Post to Feed',
        canonicalName: 'instagram_post',
        tooltip: 'Shows in your profile',
        icon: <Instagram sx={{ color: '#d62976' }} />,
    },
    {
        displayName: 'Post to Feed',
        canonicalName: 'facebook_page_post',
        tooltip: 'Shows on your wall',
        icon: <Facebook sx={{ color: '#1166ff' }} />,
    },
    {
        displayName: 'Post to Channel',
        canonicalName: 'youtube_short',
        tooltip: '',
        icon: <YouTube sx={{ color: '#ff0000' }} />,
    },
]

export const networkFromCanonical = (canonicalName) => {
    return NETWORKS.find((network) => network.canonicalName === canonicalName)
}

export const NETWORK_COMPANIES = [
    {
        displayName: 'Instagram',
        canonicalName: 'instagram',
        icon: <Instagram sx={{ color: '#d62976' }} />,
    },
    {
        displayName: 'Facebook',
        canonicalName: 'facebook_page',
        icon: <Facebook sx={{ color: '#1166ff' }} />,
    },
    {
        displayName: 'YouTube',
        canonicalName: 'youtube_channel',
        icon: <YouTube sx={{ color: '#ff0000' }} />,
    },
]

export const networkCompaniesFromCanonical = (canonicalName) => {
    return NETWORK_COMPANIES.find(
        (network) => network.canonicalName === canonicalName
    )
}

export const CAMPAIGN_TYPE_DISPLAY_NAMES = {
    blog: 'Blog',
    custom: 'Custom',
    listing: 'Listing',
    quotes: 'Quotes',
    video_submission: 'Video Clips',
}

// TODO: roll this key and move to env
export const GOOGLE_FONTS_API_KEY = 'AIzaSyAuBjCW1p5RRERnXYYhqKFwbKaVtRmLS2o'

export const RENDER_DEBOUNCE_MS = 500

const QUOTE_FORMAT = {
    type: 'quote',
    fields: [
        {
            name: 'str_quote',
            type: 'template-textbox',
            displayType: 'Text',
        },
    ],
}

const BLOG_FORMAT = {
    type: 'blog',
    fields: [
        {
            name: 'blog.title',
            type: 'template-textbox',
            displayType: 'Dynamic Text',
        },
        {
            name: 'blog.cover_image',
            type: 'template-image',
            displayType: 'Dynamic Image',
        },
    ],
}

const LISTING_FORMAT = {
    type: 'listing',
    fields: [
        {
            name: 'listing.title',
            type: 'template-textbox',
            displayType: 'Dynamic Text',
        },
        {
            name: 'listing.cover_image',
            type: 'template-image',
            displayType: 'Dynamic Image',
        },
        {
            name: 'listing.price',
            type: 'template-textbox',
            displayType: 'Dynamic Text',
        },
    ],
}

export const TEMPLATE_TYPES = {
    QUOTE: QUOTE_FORMAT,
    BLOG: BLOG_FORMAT,
    LISTING: LISTING_FORMAT,
}

export const TEMPLATE_TYPE_CODES = {
    TEXT: 100,
    BLOG: 200,
    LISTING: 300,
}

export const CAMPAIGN_TYPE_CODES = {
    TEXT: 100,
    BLOG: 200,
    LISTING: 600,
}

export const CLIP_LENGTH_CODES = {
    AUTO: 'AUTO',
    LESS_THAN_THIRTY: 'LESS_THAN_THIRTY',
    THIRTY_SIXTY: 'THIRTY_SIXTY',
    SIXTY_NINETY: 'SIXTY_NINETY',
    NINETY_PLUS: 'NINETY_PLUS',
}

export const OAUTH_CONNECTION_REQUEST_SOURCE = {
    ONBOARDING: 0,
    SETTINGS: 1,
}
